export const DEFAULT_CHART_STYLE = { height: '100%', width: '100%' };

export const ERROR_MESSAGE =
  'Something went wrong. Please try again by refreshing the page.';
